/**
 * Supports dynamic loading of CSS
 *
 * @module MW/uiframework/CSSLoader
 * @copyright Copyright 2018 The MathWorks, Inc.
 */
define(["dojo/dom-construct"],
    function (domConstruct) {

        var cssFilesLoaded = {};

        return {
            loadFile: function (file) {
                if (cssFilesLoaded[file]) {
                    return;  // File already loaded
                }
                domConstruct.create("link", {rel: "stylesheet", type: "text/css", href: file}, document.getElementsByTagName("head")[0]);
                cssFilesLoaded[file] = true;
            },

            loadFiles: function (files) {
                var that = this;
                files.forEach(function (file) {
                    that.loadFile(file);
                });
            }
        };
    });